
namespace Matrix.Indexation {

    @Serenity.Decorators.registerEditor('Matrix.Indexation.IndexationProfilePriceGrid')
    export class IndexationProfilePriceGrid extends SiteEntityGrid<IndexPriceRow, any> {
        protected getColumnsKey() { return IndexPriceColumns.columnsKey; }
        protected getDialogType() { return IndexPriceDialog; }
        protected getIdProperty() { return IndexPriceRow.idProperty; }
        protected getInsertPermission() { return IndexPriceRow.insertPermission; }
        protected getLocalTextPrefix() { return IndexPriceRow.localTextPrefix; }
        protected getService() { return IndexPriceService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        getInitialTitle() {
            return null;
        }

        private _indexationProfileCode: string;

        get indexationProfileCode(): string {
            return this._indexationProfileCode;
        }

        set indexationProfileCode(value: string) {
            if (this._indexationProfileCode != value) {
                this._indexationProfileCode = value;
                this.setEquality(IndexPriceRow.Fields.IndexationProfileCode, value);
                this.refresh();
            }
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this._indexationProfileCode;
        }
    }
}